import {
  UPDATE_QUERY_ENTITY_INFOS,
  UPDATE_QUERY,
  CLEAR_QUERY_REQUEST,
  ADD_QUERY_ENTITY_REQUEST,
  REMOVE_QUERY_ENTITY_REQUEST,
  CHANGE_AUDIENCE_TIMEFRAME_REQUEST,
  CHANGE_RESULT_TIMEFRAME_REQUEST,
  GET_AUDIENCE_REQUEST,
  GET_AUDIENCE_SUCCESS,
  GET_AUDIENCE_FAILURE,
  CREATE_AUDIENCE_FAILURE,
  CREATE_AUDIENCE_SUCCESS,
  SHOW_CREATE_AUDIENCE_MODAL,
  SHOW_EDIT_AUDIENCE_MODAL,
  CHANGE_BASE_QUERY_SUCCESS,
  RESET_QUERY_ERROR,
  CHANGE_QUERY_TYPE_REQUEST,
  CHANGE_QUERY_BUILDER_TYPE_REQUEST,
  UPDATE_CONVERSATION_QUERY_REQUEST,
  DELETE_CONVERSATION_QUERY_REQUEST,
  ADD_CONVERSATION_QUERY_REQUEST,
  MOVE_CONVERSATION_ITEM_REQUEST,
  RESET_CONVERSATION_QUERY_ERROR,
  INITIALIZE_QUERY_BUILDER,
  CHANGE_TARGET_COLOR,
  ADD_NEW_TARGET,
  REMOVE_TARGET,
  CHANGE_TARGET_TITLE,
  CHANGE_TARGET_SELECTED,
  CLEAR_ALL_QUERIES_REQUEST,
  SHOW_COMPARE_AUDIENCE_MODAL,
  ADD_AUDIENCE_TO_COMPARE_REQUEST,
  ADD_AUDIENCE_TO_COMPARE_SUCCESS,
  ADD_AUDIENCE_TO_COMPARE_FAILURE,
  OPEN_COMPARE_AFTER_SAVE,
  SET_LOADING_STATUS,
  UPDATE_TARGETS,
  GET_QUERY_MEMBERSHIP_FAILURE,
  GET_QUERY_MEMBERSHIP_SUCCESS,
  GET_QUERY_MEMBERSHIP_REQUEST,
  SET_ERROR,
  ADD_BLOCK_IN_SELECTED_GROUP_REQUEST,
  CHANGE_DATA_SOURCE,
  CHANGE_DATA_SOURCE_REQUEST,
  HIDE_CREATE_AUDIENCE_MODAL,
} from '../../constants/action-types';

import {
  createBlankSearchQuery,
  createUniqueInfoIds,
  findSelectedGroup,
} from '../../operations/query';

function setBaseQuery(state, action) {
  if (
    action.audience.metadata.base_query &&
    !action.audience.metadata.base_query.whole_population
  ) {
    return {
      ...action.audience.metadata.base_query,
    };
  }

  return { whole_population: true, query_block: null };
}

const getInitialState = () => {
  return {
    queryBuilderType: 'default',
    isLoading: false,
    error: false,
    targets: {},
    isNewQuery: false,
    isCompareQuery: false,
    dataSource: 'twitter',
  };
};

const removeConversationQuery = (
  conversationQueries,
  parentGroupId,
  entityId,
  entityType = 'item'
) => {
  if (entityType === 'group') {
    Object.keys(conversationQueries).forEach(function (key) {
      key.indexOf(entityId) > -1 && delete conversationQueries[key];
    });
  } else {
    delete conversationQueries[`${parentGroupId}_${entityId}`];
  }

  return conversationQueries;
};

const removeAndUpdateConversationQuery = (
  conversationQueries,
  parentIdFrom,
  itemId,
  parentIdTo
) => {
  const value = conversationQueries[`${parentIdFrom}_${itemId}`];
  delete conversationQueries[`${parentIdFrom}_${itemId}`];

  return {
    ...conversationQueries,
    [`${parentIdTo}_${itemId}`]: value,
  };
};

const removeTarget = (state, targetId) => {
  const { targets } = state;
  delete targets[targetId];

  const targetIds = Object.keys(targets);
  const firstTarget = targetIds[0];

  return {
    ...state,
    target_selected: firstTarget,
    targets: {
      ...targets,
    },
  };
};

const changeTargetSelected = (state, targetId) => {
  const { targets } = state;
  const newState = {
    ...state,
  };
  if (targets[targetId]) {
    newState.target_selected = targetId;
  }
  return newState;
};

const groupLoaded = (target) => {
  const groupId = findSelectedGroup(target.target_query);

  return {
    ...target,
    groupLoaded: groupId,
  };
};

const setMembershipSizeRequest = (state, action) => {
  if (!state.targets[action.targetId]) {
    return state.targets;
  }
  return {
    ...state.targets,
    [action.targetId]: {
      ...state.targets[action.targetId],
      isLoadingMembership: true,
    },
  };
};

const setMembershipSizeSuccess = (state, action) => {
  if (!state.targets[action.targetId]) {
    return state.targets;
  }
  return {
    ...state.targets,
    [action.targetId]: {
      ...state.targets[action.targetId],
      target_audience_size: action.size,
      isLoadingMembership: false,
    },
  };
};

const setMembershipSizeFailure = (state, action) => {
  if (!state.targets[action.targetId]) {
    return state.targets;
  }
  return {
    ...state.targets,
    [action.targetId]: {
      ...state.targets[action.targetId],
      isLoadingMembership: false,
    },
  };
};

const initialState = getInitialState();

const queryBuilder = (state = initialState, action) => {
  const types = {
    [INITIALIZE_QUERY_BUILDER]: () => ({
      ...state,
      isEditing: false,
      target_selected: action.targetId,
      targets: {
        ...state.targets,
        [action.targetId]: {
          query_type:
            state.queryBuilderType === 'conversation'
              ? 'conversation'
              : 'interest',
          target_label: '',
          target_color: '#007ADD',
          target_query: {
            type: 'block',
            id: 0,
            operator: 'OR',
            arguments_list: [],
          },
          queryEntitiesInfos: {},
          conversationQueries: {},
          audience_timeframe:
            state.queryBuilderType === 'conversation'
              ? 'now-6month,now'
              : 'last_year',
          results_timeframe:
            state.queryBuilderType === 'conversation'
              ? 'now-6month,now'
              : 'last_year',
          base_query: { whole_population: true, query_block: null },
        },
      },
    }),
    [UPDATE_QUERY]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          target_query: action.target_query,
          groupLoaded: null,
        },
      },
    }),
    [CLEAR_QUERY_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          target_query: createBlankSearchQuery(state.queryBuilderType),
        },
      },
    }),
    [CLEAR_ALL_QUERIES_REQUEST]: () => ({
      ...initialState,
      dataSource: state.dataSource,
      error: false,
    }),
    [ADD_QUERY_ENTITY_REQUEST]: () => ({
      ...state,
    }),
    [REMOVE_QUERY_ENTITY_REQUEST]: () => ({
      ...state,
    }),
    [UPDATE_QUERY_ENTITY_INFOS]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          queryEntitiesInfos: {
            ...state.targets[action.targetId].queryEntitiesInfos,
            [`${action.entityInfos.type}_${action.entityInfos.id}`]:
              action.entityInfos,
          },
        },
      },
      originalTargets: {
        ...action.originalTargets,
      },
    }),
    [CHANGE_AUDIENCE_TIMEFRAME_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          audience_timeframe: action.audience_timeframe,
        },
      },
    }),
    [CHANGE_RESULT_TIMEFRAME_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          results_timeframe: action.results_timeframe,
        },
      },
    }),
    [GET_AUDIENCE_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [GET_AUDIENCE_SUCCESS]: () => {
      return {
        ...state,
        queryBuilderType: action.audience.queryBuilderType,
        isLoading: false,
        isEditing: true,
        persistence: action.audience.persistence,
        target_selected: `${action.audience.id}`,
        dataSource: action.audience.metadata.data_source,
        targets: {
          [action.audience.id]: {
            target_disabled: true,
            target_query: {
              ...action.audience.metadata.target_query,
            },
            target_label: action.audience.label,
            target_color: '#007ADD',
            base_query: setBaseQuery(state, action),
            audience_timeframe:
              action.audience.metadata.audience_timeframe === null
                ? action.audience.queryBuilderType === 'conversation'
                  ? 'now-6month,now'
                  : 'last_year'
                : action.audience.metadata.audience_timeframe,
            results_timeframe:
              action.audience.metadata.results_timeframe === null
                ? action.audience.queryBuilderType === 'conversation'
                  ? 'now-6month,now'
                  : 'last_year'
                : action.audience.metadata.results_timeframe,
            query_type: action.audience.metadata.query_type,
            queryEntitiesInfos: {
              ...createUniqueInfoIds(action.queryEntitiesInfos || []),
            },
            conversationQueries: action.conversationQueries,
          },
        },
      };
    },
    [GET_AUDIENCE_FAILURE]: () => ({
      ...state,
      isLoading: false,
      error: true,
      message: action.message,
    }),
    [CREATE_AUDIENCE_SUCCESS]: () => ({
      ...initialState,
      dataSource: state.dataSource,
      error: false,
    }),
    [CREATE_AUDIENCE_FAILURE]: () => ({
      ...state,
      error: true,
      message: action.message,
    }),
    [SHOW_EDIT_AUDIENCE_MODAL]: () => ({
      ...state,
      isLoading: true,
      isNewQuery: false,
      isCompareQuery: false,
    }),
    [SHOW_CREATE_AUDIENCE_MODAL]: () => ({
      ...state,
      error: false,
      label: null,
      isNewQuery: true,
      isCompareQuery: false,
    }),
    [SHOW_COMPARE_AUDIENCE_MODAL]: () => ({
      ...state,
      error: false,
      label: null,
      isNewQuery: false,
      isCompareQuery: true,
    }),
    [CHANGE_BASE_QUERY_SUCCESS]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          base_query: action.base_query,
        },
      },
    }),
    [RESET_QUERY_ERROR]: () => ({
      ...state,
      error: false,
    }),
    [CHANGE_QUERY_TYPE_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          query_type: action.query_type,
          audience_timeframe: 'last_year',
          results_timeframe: 'last_year',
        },
      },
    }),
    [CHANGE_QUERY_BUILDER_TYPE_REQUEST]: () => ({
      ...state,
      queryBuilderType: action.queryBuilderType,
    }),
    [ADD_CONVERSATION_QUERY_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          conversationQueries: {
            ...state.targets[action.targetId].conversationQueries,
            [`${action.parentGroupId}_${action.entityId}`]:
              action.entityContent,
          },
        },
      },
      message: undefined,
    }),
    [UPDATE_CONVERSATION_QUERY_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          conversationQueries: {
            ...state.targets[action.targetId].conversationQueries,
            [`${action.parentGroupId}_${action.entityId}`]:
              action.entityContent,
          },
        },
      },
      message: undefined,
    }),
    [DELETE_CONVERSATION_QUERY_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          conversationQueries: removeConversationQuery(
            state.targets[action.targetId].conversationQueries,
            action.parentGroupId,
            action.entityId,
            action.entityType
          ),
        },
      },
      message: undefined,
    }),
    [MOVE_CONVERSATION_ITEM_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          conversationQueries: removeAndUpdateConversationQuery(
            state.targets[action.targetId].conversationQueries,
            action.parentIdFrom,
            action.itemId,
            action.parentIdTo
          ),
        },
      },
      message: undefined,
    }),
    [RESET_CONVERSATION_QUERY_ERROR]: () => ({
      ...state,
      error: false,
      message: undefined,
    }),
    [CHANGE_TARGET_SELECTED]: () =>
      changeTargetSelected(state, action.targetId),
    [CHANGE_TARGET_COLOR]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          target_color: action.color,
        },
      },
    }),
    [CHANGE_TARGET_TITLE]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: {
          ...state.targets[action.targetId],
          target_label: action.title,
        },
      },
    }),
    [ADD_NEW_TARGET]: () => ({
      ...state,
    }),
    [REMOVE_TARGET]: () => removeTarget(state, action.targetId),
    [UPDATE_TARGETS]: () => ({
      ...state,
      target_selected: action.targetId,
      targets: action.targets,
    }),
    [ADD_AUDIENCE_TO_COMPARE_REQUEST]: () => ({
      ...state,
      isLoading: true,
    }),
    [ADD_AUDIENCE_TO_COMPARE_SUCCESS]: () => ({
      ...initialState,
      error: false,
    }),
    [ADD_AUDIENCE_TO_COMPARE_FAILURE]: () => ({
      ...state,
      error: true,
      message: action.message,
    }),
    [SET_LOADING_STATUS]: () => ({
      ...state,
      isLoading: action.loading,
    }),
    [SET_ERROR]: () => ({
      ...state,
      error: true,
      message: action.message,
    }),
    [OPEN_COMPARE_AFTER_SAVE]: () => ({
      ...state,
      isLoading: false,
    }),
    [GET_QUERY_MEMBERSHIP_REQUEST]: () => ({
      ...state,
      targets: setMembershipSizeRequest(state, action),
    }),
    [GET_QUERY_MEMBERSHIP_SUCCESS]: () => ({
      ...state,
      targets: setMembershipSizeSuccess(state, action),
    }),
    [GET_QUERY_MEMBERSHIP_FAILURE]: () => ({
      ...state,
      targets: setMembershipSizeFailure(state, action),
    }),
    [ADD_BLOCK_IN_SELECTED_GROUP_REQUEST]: () => ({
      ...state,
      targets: {
        ...state.targets,
        [action.targetId]: groupLoaded(state.targets[action.targetId]),
      },
    }),
    [CHANGE_DATA_SOURCE]: () => ({
      ...state,
      dataSource: action.dataSource,
    }),
    [CHANGE_DATA_SOURCE_REQUEST]: () => ({
      ...state,
      dataSource: action.dataSource,
    }),
    [HIDE_CREATE_AUDIENCE_MODAL]: () => ({
      ...state,
    }),
  };

  if (!types[action.type]) {
    return state;
  }

  return types[action.type]();
};

export default queryBuilder;
